import api from '@/utils/api'

export const fetchNotifications = (user, params) => {
  return api.get(`/notifications/`, {params: params})
    .then(resp => {
      return (resp.data)
    })
}
export const readAll = (user) => {
  return api.put(`/notifications/read/`)
    .then(resp => {
      return (resp.data)
    })
}

export const fetchUserSettings = () => {
  return api.get(`/notifications/user_settings/`)
    .then(resp => {
      return (resp.data)
    })
}

export const updateUserSettings = (data) => {
  return api.put(`/notifications/user_settings/`, data)
    .then(resp => {
      return (resp.data)
    })
}



// WEBPACK FOOTER //
// ./src/notifications/api.js